import styled from "styled-components";

export const SecurityQuestionStyle = styled.div`
    margin-inline: 20px;
    padding-block: 75px;
    height: calc(100vh - 150px);
`;

export const SecurityForm = styled.form``;
